import { put, takeLatest } from 'redux-saga/effects';
import api from '../../../../utils/apiConfig';
import PaymentActionTypes from './types';
import {
  fetchConsignerPaymentDetailsSuccess,
  fetchConsignerPaymentDetailsFailure,
  initiateConsignerPaymentFailure,
  initiateConsignerPaymentSuccess,
  initiateConsignerPaymentStatusFailure,
  initiateConsignerPaymentStatusSuccess,
  fetchConsignerDocumentSuccess,
  fetchConsignerDocumentFailure,
} from './actions';
import UrlConfig from './urls';

function* getConsignerPaymentsDetailsSaga(action: any) {
  const requestURL: any = UrlConfig.getPaymentdetails(action.payload);
  try {
    const response = yield api.get(requestURL);
    yield put(fetchConsignerPaymentDetailsSuccess(response));
  } catch (e) {
    yield put(fetchConsignerPaymentDetailsFailure(e));
    console.log({ e });
  }
}

function* getConsignerDocumentSaga(action: any) {
  const requestURL: any = UrlConfig.getDocument(action.payload);
  try {
    const response = yield api.get(requestURL);
    yield put(fetchConsignerDocumentSuccess(response));
  } catch (e) {
    yield put(fetchConsignerDocumentFailure(e));
    console.log({ e });
  }
}

function* postInitiatePaymentsSaga(action: any) {
  const requestURL = UrlConfig.initiatePayment();

  try {
    const response = yield api.post(requestURL, action.payload);
    if (!!response?.data?.errorCode && response.data.errorCode !== '200') {
      yield put(initiateConsignerPaymentFailure(response?.data?.message || 'Something went wrong'));
    } else {
      yield put(initiateConsignerPaymentSuccess(response));
    }
  } catch (e) {
    yield put(initiateConsignerPaymentFailure(e));
    console.log({ e });
  }
}

function* postInitiateConsignerPaymentStatusSaga(action: any) {
  const requestURL = UrlConfig.initiatePaymentStatus(action.payload);

  try {
    const response = yield api.post(requestURL, action.payload);
    if (!!response?.data?.errorCode && response.data.errorCode !== '200') {
      yield put(initiateConsignerPaymentStatusFailure(response?.data?.message || 'Something went wrong'));
    } else {
      const paymentData = response.data.data;

      yield put(initiateConsignerPaymentStatusSuccess(response));
    }
  } catch (e) {
    yield put(initiateConsignerPaymentStatusFailure(e));
    console.log({ e });
  }
}

function* consignerPaymentSaga() {
  yield takeLatest(PaymentActionTypes.FETCH_CONSIGNER_PAYMENT_DETAILS_START, getConsignerPaymentsDetailsSaga);
  yield takeLatest(PaymentActionTypes.FETCH_CONSIGNER_DOCUMENT_START, getConsignerDocumentSaga);
  yield takeLatest(PaymentActionTypes.INITIATE_CONSIGNER_PAYMENT_START, postInitiatePaymentsSaga);
  yield takeLatest(PaymentActionTypes.INITIATE_CONSIGNER_PAYMENT_STATUS_START, postInitiateConsignerPaymentStatusSaga);
}
export default consignerPaymentSaga;
